const yesno = value => value ? 'Yes' : 'No'

export default {
    yesno
}
